import { storytelProducers } from "./storytelProducers";
import { storytelPublishers } from "./storytelPublishers";

export const selectableStatisticQuestions = {
	calculateDurationForStorytelProducers: storytelProducers,
	calculateDurationForStorytelPublishers: storytelPublishers,
};
